import Vue from 'vue';
//模块功能：发展历程
export default Vue.extend({
    name: "history",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {}
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/about/history.vue
// module id = null
// module chunks = 